import React, { Component } from 'react'
import { Card, CardBody, } from 'reactstrap'
import { ItemBasicNav, ItemQuestion, ItemFeedback } from '../'
import { CurrentQuestionAlert, ItemAnswers, } from './'

class CurrentQuestion extends Component {
  render() {


    const { 
      getQuestionPosition,
      activeItemTransitionCN,
      itemNumber,
      lastItemNumber,
      isGroup,
      assessmentId,
      selectedStudent,
      completed,
      handleChangeItem,
      activeItem,
      selectedAnswer,
      answersByItem,
      user,
      selectAnswer,
      correctAnswer,
      questionCurrentRef,
    } = this.props
    return (
      <div ref={(questionCurrent) => questionCurrentRef(questionCurrent)}>
        <Card className={`question active non-math ${getQuestionPosition()} ${activeItemTransitionCN}`}>
          <div className="prev-nav-link">
            <ItemBasicNav
              itemNumber={itemNumber}
              lastItemNumber={lastItemNumber}
              isGroup={isGroup}
              assessmentId={assessmentId}
              selectedStudent={selectedStudent}
              prev={true}
              completed={completed}
              handleChangeItem={handleChangeItem}
            />
          </div>
          <CardBody>
            <div className='question-number'>
              {activeItem && `Question ${itemNumber ? itemNumber : '1'} of ${lastItemNumber}`}
            </div>
            <ItemQuestion question={activeItem ? activeItem.question : null} />
            {activeItem && 
              <ItemAnswers 
                activeItem={activeItem}
                isGroup={isGroup}
                answersByItem={answersByItem}
                selectedAnswer={selectedAnswer}
                selectAnswer={selectAnswer}
                completed={completed}
              />
            }
            {activeItem && 
              <ItemFeedback 
                feedback={selectedAnswer ? activeItem.answers[selectedAnswer].feedback : activeItem.answers[correctAnswer].feedback}
                completed={completed}
              />
            }
            <CurrentQuestionAlert 
              answersByItem={answersByItem}
              user={user}
              selectedStudent={selectedStudent}
              selectedAnswer={selectedAnswer}
              isGroup={isGroup}
              activeItem={activeItem}
            />
          </CardBody>
          <div className="next-nav-link">
            <ItemBasicNav
              itemNumber={itemNumber}
              lastItemNumber={lastItemNumber}
              isGroup={isGroup}
              assessmentId={assessmentId}
              selectedStudent={selectedStudent}
              next={true}
              completed={completed}
              handleChangeItem={handleChangeItem}
            />
          </div>
        </Card>
      </div>
    )
  }
}

export default CurrentQuestion


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessTestComponents/CurrentQuestion.js